import React from 'react'
import TechnicalDifficultiesMessage from 'components/Client/TechnicalDifficultiesMessage/TechnicalDifficultiesMessage'

import {
  BaseComponent
} from 'belle-js'


const withTechnicalDifficultiesErrorMessage = (Component) => {
  class Container extends BaseComponent {

    render () {
      const {
        showError,
        layout,
        context
      } = this.props

      if (showError) {
        return <TechnicalDifficultiesMessage context={context} layout={layout} />
      }
      return Component
    }

  }
  return Container
}

export default withTechnicalDifficultiesErrorMessage



// WEBPACK FOOTER //
// ./src/components/Client/withTechnicalDifficultiesErrorMessage.jsx